import type { ReactElement } from 'react';

import { useSwitchActiveCompany } from '@/lib/active-company-context';
import type { DocumentCompanyAccess } from '@/lib/document-company';

// Aviso de una tarjeta de la ficha que consulta bajo la empresa activa cuando esa empresa
// no es la del documento, o no hay ninguna (hallazgos H4/H7 del 2026-10-14). Explica qué
// pasa y, si se puede, ofrece cambiar a la empresa del documento.

export function CompanyScopeNote({
  access,
  subject,
}: {
  access: Exclude<DocumentCompanyAccess, { kind: 'active' }>;
  /** Qué se vería con la empresa correcta, en minúscula: "su capacitación". */
  subject: string;
}): ReactElement {
  const switchTo = useSwitchActiveCompany();
  let text: string;
  if (access.kind === 'no-active') {
    text = `Elige la empresa activa para ver ${subject}.`;
  } else if (access.name === null) {
    text = `Este documento es de otra empresa. Para ver ${subject}, la empresa activa debe ser la del documento.`;
  } else {
    text = `Este documento es de ${access.name}. Cambia la empresa activa a ${access.name} para ver ${subject}.`;
  }
  return (
    <div className="cb">
      <p className="soft" style={{ fontSize: 12.5, margin: 0 }}>
        {text}
      </p>
      {access.kind === 'other' && access.name !== null && (
        <button
          type="button"
          className="btn mut sm"
          style={{ marginTop: 10 }}
          onClick={() => switchTo(access.companyId)}
        >
          {`Cambiar a ${access.name}`}
        </button>
      )}
    </div>
  );
}
